import { render } from "./SettingTable.vue?vue&type=template&id=aa3e3d60"
import script from "./SettingTable.vue?vue&type=script&lang=ts"
export * from "./SettingTable.vue?vue&type=script&lang=ts"
script.render = render

export default script